import { inject } from '@angular/core'
import { CanActivateChildFn, Router } from '@angular/router'
import { OrgContextService } from '../core/services/org-context.service'

/**
 * Re-checks `OrgContextService.productAccessAllowed()` on EVERY child
 * navigation attempt inside the authed layout (sidebar links, browser back/
 * forward, a pasted `/c/:id` url, etc.) — not just once on load.
 *
 * `LayoutComponent`'s own `effect()` only redirects when the
 * `productAccessAllowed` signal itself *changes value* (e.g. an admin
 * revokes access mid-session); it does not re-run on navigation, so without
 * this guard a user already parked on `/product-disabled` could navigate
 * straight to an existing chat/folder and keep using the product. This guard
 * closes that gap by gating every navigation, independent of the signal's
 * last transition.
 */
export const productAccessGuard: CanActivateChildFn = (_childRoute, state) => {
  const org = inject(OrgContextService)
  const router = inject(Router)

  if (org.productAccessAllowed() || state.url.startsWith('/product-disabled')) {
    return true
  }
  return router.parseUrl('/product-disabled')
}
